import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

let mermaidInitialized = false;
let idCounter = 0;

function initMermaid() {
  if (mermaidInitialized) return;
  mermaid.initialize({
    startOnLoad: false,
    theme: 'base',
    themeVariables: {
      primaryColor: '#e0f2f1',
      primaryTextColor: '#1e293b',
      primaryBorderColor: '#004f4f',
      lineColor: '#64748b',
      fontSize: '15px',
    },
  });
  mermaidInitialized = true;
}

interface MermaidChartProps {
  chart: string;
  caption?: string;
}

export function MermaidChart({ chart, caption }: MermaidChartProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    initMermaid();
    if (!ref.current) return;
    const id = `mermaid-chart-${++idCounter}`;
    mermaid
      .render(id, chart.trim())
      .then(({ svg }) => {
        if (ref.current) ref.current.innerHTML = svg;
      })
      .catch((err) => {
        const message = err instanceof Error ? err.message : "Nieznany błąd";
        if (ref.current)
          ref.current.textContent = `Błąd diagramu: ${message}`;
      });
  }, [chart]);

  return (
    <figure className="my-8">
      <div
        ref={ref}
        className="overflow-x-auto flex justify-center"
        role="img"
        aria-label={caption ?? 'Diagram'}
      />
      {caption && (
        <figcaption className="text-center text-sm text-slate-500 mt-3 italic">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
